import { Component, OnInit, Input } from '@angular/core';
import { DetailReportCategory } from '../../../../models/reporting';
import { MathRoundHelper } from '../../../../helpers';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styles: []
})
export class CategoriesComponent implements OnInit {
@Input() detailReportCategories: Array<DetailReportCategory>;
  constructor() { }

  ngOnInit() {
    this.detailReportCategories.forEach(x => {
          x.averageValue = MathRoundHelper.roundToFixedNumber(x.averageValue, 1);
          x.questions = x.questions.sort((q1, q2) => q1.order - q2.order);
    });
  }
}
